import { combineReducers } from 'redux';
import { UserAction, UserActionType } from '../../actions/userActions';

const requestingSlackInvite = (state = false, action: UserAction) => {
  switch (action.type) {
    case UserActionType.REQUEST_SLACK_INVITE:
      return true;
    case UserActionType.REQUEST_SLACK_INVITE_OK:
    case UserActionType.REQUEST_SLACK_INVITE_ERROR:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  requestingSlackInvite,
});
